import { render, staticRenderFns } from "./quantity-chooser.vue?vue&type=template&id=643c23d2"
import script from "./quantity-chooser.vue?vue&type=script&lang=js"
export * from "./quantity-chooser.vue?vue&type=script&lang=js"
import style0 from "./quantity-chooser.vue?vue&type=style&index=0&id=643c23d2&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports